import { Box } from '@factorialco/deprecated-design-system'
import { F0AvatarTeam, F0Text } from '@factorialco/f0-react'
import { Handle, NodeProps, Position } from '@xyflow/react'

import { InjectHoverProvider } from 'modules/core/lib/hoverContext'

import Checkbox from 'modules/job_catalog/components/DevJobCatalogTree/components/Checkbox'
import CollapsibleButton from 'modules/job_catalog/components/DevJobCatalogTree/components/CollapsibleButton'
import CollapsibleLine from 'modules/job_catalog/components/DevJobCatalogTree/components/CollapsibleLine'
import { useTreeContext } from 'modules/job_catalog/components/DevJobCatalogTree/context'
import {
  getNodeBackgroundColor,
  getNodeBorderColor,
} from 'modules/job_catalog/components/DevJobCatalogTree/treeUtils'
import { CustomNode, SIZES } from 'modules/job_catalog/components/DevJobCatalogTree/types'
import { NODE_TYPES, normalizeNodeType } from 'modules/job_catalog/lib/nodesUtils'

const Node = (props: NodeProps<CustomNode>) => {
  const { onToggleExpand } = useTreeContext()
  const hasChildren = props.data.childrenCount > 0
  const nodeType = normalizeNodeType(props.data.type)
  const isRootNode = nodeType === NODE_TYPES.ROOT

  return (
    <InjectHoverProvider>
      <Box justifyContent="center" alignItems="center">
        <Box
          background={getNodeBackgroundColor(props.data.checked)}
          border={{
            all: {
              color: getNodeBorderColor(props.selected, props.data.checked),
              style: 'solid',
              width: 's1',
            },
          }}
          style={{ width: `${SIZES.NODE_WIDTH}px`, height: `${SIZES.NODE_HEIGHT}px` }}
          borderRadius={{ all: 'abs012' }}
          alignItems="center"
          justifyContent="center"
          gap="s12"
          padding="s8"
        >
          {!isRootNode && (
            <Box style={{ position: 'absolute', top: '6px', right: '6px' }}>
              <Checkbox
                nodeId={props.id}
                checked={props.data.checked}
                disabled={props.data.multiselectDisabled}
              />
            </Box>
          )}
          <F0AvatarTeam size="lg" name={props.data.name} />
          <F0Text content={props.data.name} ellipsis variant="label" />
        </Box>
        <Handle type="target" position={Position.Top} style={{ visibility: 'hidden' }} />
        <Handle type="source" position={Position.Bottom} style={{ visibility: 'hidden' }} />
        {hasChildren && (
          <>
            <CollapsibleLine />
            <CollapsibleButton
              childrenCount={props.data.childrenCount}
              isExpanded={props.data.expanded}
              onClick={() => onToggleExpand(props.id)}
            />
          </>
        )}
      </Box>
    </InjectHoverProvider>
  )
}

export default Node
